import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "file-loader-area",
  for: "formFile",
  "aria-label": "Área de upload de arquivos."
}
const _hoisted_3 = {
  key: 1,
  class: "file-loader-area file-dragging"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  class: "btn w-100 btn-outline-primary mt-2",
  for: "formFile",
  "aria-label": "Botão de upload de arquivos."
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (!_ctx.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "w-100",
          onDrop: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.drop && _ctx.drop(...args))),
          onDragenter: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.dragOver && _ctx.dragOver(...args))),
          onDragleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.dragleave && _ctx.dragleave(...args)))
        }, [
          (!_ctx.isDragging)
            ? (_openBlock(), _createElementBlock("label", _hoisted_2, _cache[5] || (_cache[5] = [
                _createStaticVNode("<div class=\"file-loader-area__icon\" data-v-0852ec48><img class=\"icon icon-img\" src=\"https://cdn.soluti.com.br/libs/ilios/latest/img/icons/upload.svg\" data-v-0852ec48></div><div class=\"file-loader-area__text\" data-v-0852ec48><strong data-v-0852ec48>Clique para inserir</strong> ou arraste e solte o documento</div><div class=\"file-loader-area__file-spec\" data-v-0852ec48>Formatos permitidos: JPEG, PNG, PDF, Word</div><div class=\"file-loader-area__file-spec\" data-v-0852ec48>Tamanho máximo permitido: 25 MB por documento</div>", 4)
              ])))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[6] || (_cache[6] = [
                _createElementVNode("div", { class: "file-loader-area__text" }, null, -1),
                _createElementVNode("strong", null, "Solte o documento aqui!", -1)
              ]))),
          _createElementVNode("input", {
            class: "d-none",
            id: "formFile",
            multiple: "",
            ref: "file",
            type: "file",
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.inputChange && _ctx.inputChange(...args)))
          }, null, 544)
        ], 32)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, [
          _cache[7] || (_cache[7] = _createElementVNode("span", null, "Anexar documentos", -1)),
          _createVNode(_component_Icon, {
            class: "ms-2",
            style: "width: 1.5rem; height: 1.5rem;",
            name: "cloud-arrow-up"
          })
        ]),
        _createElementVNode("input", {
          class: "d-none",
          id: "formFile",
          multiple: "",
          ref: "file",
          type: "file",
          onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.inputChange && _ctx.inputChange(...args)))
        }, null, 544)
      ]))
}